import React, { useState } from "react";
import Fonts from "../../../../stories/assets/Fonts";
import Colors from "../../../../stories/assets/Colors";
import ModalSkeleton from "../../../ModalSkeleton/ModalSkeleton";
import { Button } from "../../../../stories/Button/Button";
import classes from "./SavedRepliesModal.module.css";
import { Checkbox } from "../../../../stories/Checkbox/Checkbox";
import { LinkButtonWithIcon } from "../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";

const SavedRepliesModal = ({ show, setShow }) => {
  const [pagitnationSteps, setPagitnationSteps] = useState(1);

  const [savedRepliesState, setSavedRepliesState] = useState([]);

  return (
    <>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        borderRadius={"20px"}
        width={"468px"}
        height={"188px"}
        padding={"32px"}
        showCloseIcon={true}
        footer={
          <div className={classes.btnBox}>
            <LinkButtonWithIcon primary={false} text="Cancel" customStyle={{ marginRight: "48px", color: Colors.neutralShadesOfNero }} onClick={() => setShow(false)} />
            <Button
              size="Medium"
              label="Send"
              primary={true}
              style={{
                width: "max-content",
                padding: "14px 42.5px"
              }}
              onClick={() => setShow(false)}
            />
          </div>

        }
      >
        <div className={classes.modalContent}>
          <h4 style={{ ...Fonts.h4f26, color: Colors.neutralShadesOfNero }}>
            Saved Replies
          </h4>

          <Checkbox
            value={savedRepliesState}
            setValue={setSavedRepliesState}
            label={"Cancellation reasons"}
          />
          <Checkbox
            value={savedRepliesState}
            setValue={setSavedRepliesState}
            label={"Problem solved"}
          />

        </div>
      </ModalSkeleton>
    </>
  );
};

export default SavedRepliesModal;
